module.exports = __webpack_public_path__ + "img/upload.59fabfc2.svg";